import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UpgradeModalComponent } from './upgrade-modal/upgrade-modal.component';
import { InboxAutomatorModalComponent } from './inbox-automator/inbox-automator-modal.component';
import { InboxAutomatorPillComponent } from './inbox-automator/inbox-automator-pill.component';

/**
 * SD-1229: plan-gated UI that can appear on any page -- the upgrade modal, the Inbox
 * Automator modal, and the Inbox Automator pill. The modals open through root services
 * (UpgradeModalService, InboxAutomatorModalService); only the pill is used in templates.
 */
@NgModule({
  imports: [CommonModule, RouterModule, NgbModalModule, MatProgressSpinnerModule],
  declarations: [UpgradeModalComponent, InboxAutomatorModalComponent, InboxAutomatorPillComponent],
  exports: [InboxAutomatorPillComponent]
})
export class BillingUiModule { }
